export default __webpack_public_path__ + "static/media/rightarrow.4424c765.svg";